/**
 * dataLayer helpers. GTM container is loaded from public/index.html.
 * GA4 and Meta Pixel are configured in the GTM UI.
 */
export type DataLayerPayload = Record<string, unknown>;

export function pushToDataLayer(payload: DataLayerPayload): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}
